/**
 * A helper function that returns a string representation of an object.
 *
 * @param [detectCycles=false] If set to true will keep a reference to every object in the value and
 *   will not expand duplicates. Default is `false`
 */
export function jsonStringify(
  value: unknown,
  detectCycles = false,
  space: number | undefined = 2
): string {
  if (!detectCycles) {
    return JSON.stringify(value, null, space);
  }

  const visited = new Set<unknown>();

  function replacer(_key: string, value: unknown) {
    if (visited.has(value)) return null;
    visited.add(value);
    return value;
  }

  return JSON.stringify(value, replacer, space);
}
